/**
 * "DID YOU MEAN …?" — the common domain slips, caught before a player locks
 * themselves out of their own winnings. It NEVER blocks anybody: the player can
 * keep exactly what they typed.
 */
const FIXES = {
    'gmail.co': 'gmail.com',
    'gmail.con': 'gmail.com',
    'gmail.cm': 'gmail.com',
    'gmail.om': 'gmail.com',
    'gmaill.com': 'gmail.com',
    'gmial.com': 'gmail.com',
    'gmai.com': 'gmail.com',
    'gmil.com': 'gmail.com',
    'gnail.com': 'gmail.com',
    'gamil.com': 'gmail.com',
    'hotmail.co': 'hotmail.com',
    'hotmail.con': 'hotmail.com',
    'hotmial.com': 'hotmail.com',
    'hotmai.com': 'hotmail.com',
    'hotmali.com': 'hotmail.com',
    'homail.com': 'hotmail.com',
    'yahoo.co': 'yahoo.com',
    'yahoo.con': 'yahoo.com',
    'yaho.com': 'yahoo.com',
    'yahooo.com': 'yahoo.com',
    'yhaoo.com': 'yahoo.com',
    'outlook.co': 'outlook.com',
    'outlook.con': 'outlook.com',
    'outlok.com': 'outlook.com',
    'outloook.com': 'outlook.com',
    'icloud.co': 'icloud.com',
    'icloud.con': 'icloud.com',
    'iclould.com': 'icloud.com',
    'icloud.cm': 'icloud.com',
    'videotron.c': 'videotron.ca',
    'videotron.com': 'videotron.ca',
    'sympatico.c': 'sympatico.ca',
    'bell.ne': 'bell.net',
    'live.co': 'live.com',
    'live.con': 'live.com',
    'me.co': 'me.com',
    'aol.con': 'aol.com',
};

/** The address we think they meant, or '' when it already looks fine. */
export const emailSuggestion = (raw) => {
    const value = String(raw || '').trim();
    const at = value.lastIndexOf('@');
    if (at < 1 || at === value.length - 1) return '';
    const local = value.slice(0, at);
    const domain = value.slice(at + 1).toLowerCase();
    const fixed = FIXES[domain];
    return fixed ? `${local.toLowerCase()}@${fixed}` : '';
};

export default emailSuggestion;
